import { OnInit, Component } from '@angular/core';

@Component({
  selector: 'app-reportes-uac',
  templateUrl: './reporte-UAC.component.html',
  styleUrls: ['./reporte-UAC.component.scss']
})

export class ReporteUACComponent implements OnInit {

  public filtroReporte: string;

  ngOnInit() {
    this.filtroReporte = '1';
  }
}
